import React from 'react';

import { BarryAssistantMessageBubble } from './BarryAssistantMessageBubble';
import { BarryUserMessageBubble } from './BarryUserMessageBubble';
import { type ChatItem } from './types/chatItem';

interface BarryConversationMessagesProps {
	items: ChatItem[];
	messagesEndRef: React.RefObject<HTMLDivElement>;
}

const renderChatItem = (item: ChatItem): React.ReactNode => {
	switch (item.kind) {
		case 'user':
			return (
				<BarryUserMessageBubble
					key={item.id}
					content={item.content}
					visualization={item.visualization}
				/>
			);
		case 'assistant':
			return (
				<BarryAssistantMessageBubble
					key={item.id}
					content={item.content}
					visualization={item.visualization}
				/>
			);
		case 'status':
			return (
				<BarryAssistantMessageBubble
					key={item.id}
					content={item.content}
					isItalic
				/>
			);
	}
};

export const BarryConversationMessages: React.FC<BarryConversationMessagesProps> = (
	props,
) => {
	const { items, messagesEndRef } = props;

	return (
		<>
			{items.map(renderChatItem)}
			<div ref={messagesEndRef} />
		</>
	);
};
